import { Component, OnInit, OnDestroy } from '@angular/core';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  RouteConfigLoadEnd,
  RouteConfigLoadStart,
  Router,
  RoutesRecognized,
} from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { environment } from '../../../environments/environment';
import { AuthenticationService } from '../../services/authentication.service';
import { AuthService } from '../../services/auth.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  showLogout: boolean = false;
  popIaDisclosureLink: string = '';
  private destroy$ = new Subject<void>();

  constructor(
    private router: Router,
    private oidcSecurityService: OidcSecurityService,
    private authenticationService: AuthenticationService,
    private authService: AuthService
  ) {
    this.router.events.pipe(takeUntil(this.destroy$)).subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.updateLogoutVisibility();
      }
    });
  }

  ngOnInit(): void {
    this.popIaDisclosureLink =
      environment.afUrlbase + environment.endPoints.popIaDisclosure;

    // Subscribe to authentication status changes only once
    this.authService.isAuthenticated$
      .pipe(takeUntil(this.destroy$))
      .subscribe((isAuthenticated) => {
        this.updateShowLogout(isAuthenticated);
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private updateShowLogout(isAuthenticated: boolean): void {
    this.showLogout =
      isAuthenticated && !['/login', '/'].includes(this.router.url);
  }

  updateLogoutVisibility() {
    // Simply update based on current route and auth status from BehaviorSubject
    this.updateShowLogout(this.authService.currentAuthStatus);
  }

  logoutAndExitEac() {
    const redirectUrl =
      environment.afoUrlbase + environment.endPoints.memberValues;
    this.authService.logoutAndRedirect(redirectUrl);
  }

  logout() {
    this.authService.logout();
  }
}
